import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
    //список акций
      publishedItems:[],
      activeItems:[],
      sizesStock: [{value: 0, text: "Большая плитка (3x3)"}, {value: 1, text: "Средняя (2x2)"}, {
          value: 2,
          text: "Маленькая (1x1)"
      }],
      orgItems:[]

  },
  actions,
  mutations,
  getters
}
